import React, { useEffect, useLayoutEffect } from 'react'
import './loading-page.styles.scss'

import Loader from '@/components/loader/loader.comp'
import { useDispatch, useSelector } from 'react-redux'
import { auth, UseCloudFunction } from '@/utils/firebase.utils'
import { useNavigate, useParams } from 'react-router-dom'
import { setUserProfile } from '@/state/slices/userSlice'


const LoadingPage = () => {

    const userProfile = useSelector(state => state.userData.userProfile);
    const currentUser = useSelector(state => state.userData.currentUser);
    const myLeagues = useSelector(state => state.contentData.myLeagues);
    const { refreshProfile } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        getUserProfile();
    }, [])

    useEffect(() => {
        if (!currentUser || !userProfile) return;
        navigate('/home') 
    }, [currentUser, userProfile])

    async function getUserProfile() {
        if (refreshProfile === 'refresh' || !userProfile) {
            
            const profile = await UseCloudFunction('signIn');
            console.log(profile);
            if (profile.claimsChanged) {
                // Pick up the new admin claim so security rules see it.
                await auth.currentUser?.getIdToken(true);
            }
            if (profile.profile && profile.profile.name) {
                dispatch(setUserProfile(profile.profile))
            } else if (!profile.profile || !profile.profile.name) {
                navigate('/profile');
                return;
            } 
            navigate('/home')
            
        } else {
            navigate('/home')
        }
    }

    return (
        <div className='loading-page'>
            {/* <div className='loader-icon'>
                <img src={require('assets/icon.png')} />
            </div> */}
            <Loader />  
        </div>
    )
}

export default LoadingPage